<template>
  <FormGroup>
    <h5 class="name">คุณสมบัติของรายการ</h5>
    <div class="form-check" @click.stop="changeOptionValue('audioDesc')">
      <input type="checkbox"
        class="form-check-input"
        :checked="features.audioDesc"
        @input="$emit('update:features', { ...features, audioDesc: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        เสียงบรรยายภาพ (Audio Desc)
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('signLanguage')">
      <input type="checkbox"
        class="form-check-input"
        :checked="features.signLanguage"
        @input="$emit('update:features', { ...features, signLanguage: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
         ผู้บรรยายภาษามือ (Sign Language)
       </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('soundtrack')">
      <input type="checkbox"
        class="form-check-input"
        :checked="features.soundtrack"
        @input="$emit('update:features', { ...features, soundtrack: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        เสียงซาวด์แทร็ก
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('closedCaptions')">
      <input type="checkbox"
        class="form-check-input"
        :checked="features.closedCaptions"
        @input="$emit('update:features', { ...features, closedCaptions: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        คำบรรยายแบบปิด (Closed Captions)
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('restrictedLicense')">
      <input type="checkbox"
        class="form-check-input"
        :checked="features.restrictedLicense"
        @input="$emit('update:features', { ...features, restrictedLicense: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        ติดลิขสิทธิ์
      </label>
    </div>
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    features: {
      type: Object,
      default: () => {},
    },
    updateFeatureStateError: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormGroup,
  },
  methods: {
    changeOptionValue(keyName) {
      if (!this.disabled) {
        const value = _.get(this.features, keyName, null);
        _.set(this.features, keyName, !value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.form-check-label {
  cursor: pointer;
}

.form-check {
  margin-bottom: $spacer * 0.35;
}
</style>
